module.exports = __webpack_public_path__ + "static/img/fail.02d1ecb.png";


//////////////////
// WEBPACK FOOTER
// ./static/pay/fail.png
// module id = 3CHx
// module chunks = 1